<template>
    <CMultiSelect
        :options="sortOptions ? sortedOptions : options"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @change="onChange"
    />
</template>

<script setup>
import { CMultiSelect } from '@coreui/vue-pro'
import { computed } from 'vue'
import _ from 'lodash'

const emit = defineEmits(['change', 'update'])
const props = defineProps({
    options: {
        type: Array,
        default: () => []
    },
    sortOptions: {
        type: Boolean,
        default: false
    },
    invalidFeedback: {
        type: String,
        default: null
    }
})

const invalid = computed(() => props.invalidFeedback !== null)

const sortedOptions = computed(() => _.sortBy(props.options, [option => option.text.toLowerCase()], ['text']))

const onChange = (values) => {
    // Numbers as strings: pages store the selection and compare it with `String(item.value)`, and
    // filters restored from the query string are strings too. Objects and strings pass unchanged.
    emit('update', values.map((element) => typeof element.value === 'number' ? String(element.value) : element.value))
}
</script>

<style>
.dropdown-menu {
    width: 100% !important;
}

.form-multi-select.form-multi-select-with-cleaner {
    padding-right: 2rem !important;
}

.form-multi-select-input-group::before{
    content: "";
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
}
</style>
